var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticClass:"voice-data",attrs:{"gutter":20}},[_c('a-col',{staticClass:"row",attrs:{"span":10}},[_c('voice-data-list',{on:{"selectRow":_vm.selectRow}})],1),_c('a-col',{staticClass:"row",attrs:{"span":14}},[_c('voice-data-patient-list',{attrs:{"voiceBatchId":_vm.voiceBatchId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }